import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { isset } from '@cawita/core-front';
import { isEmptyOrNotSet } from '@hints/utils/data';
import { isString } from '@hints/utils/types';
import { User } from '@shared/models';
import { TesterAuthAPI } from '@shared/services/tester-auth.api';
import { map, Observable, of, switchMap, timer } from 'rxjs';
import { provideAsyncValidator } from '../simple-value-accessor.directive';

@Directive({
  selector: '[cwtUniqueLogin]',
  standalone: true,
  providers: [provideAsyncValidator(forwardRef(() => UniqueLoginDirective))]
})
export class UniqueLoginDirective implements AsyncValidator {
  constructor(private auth: TesterAuthAPI) { }
  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const login = isString(control.value) ? control.value : '';
    if(isEmptyOrNotSet(login)) return of(null);
    return timer(500).pipe(
      switchMap(() => this.auth.checkLogin(login)),
      map(available => !available ? { uniqueLogin: true } : null)
    );
  }
}
